import React, { forwardRef, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { uniqBy } from 'lodash';
import { FieldTypes } from 'utils/formUtils';
import GenericMappingForm from '../GenericMappingForm';

const RiskReconMappingForm = forwardRef(function RiskReconMappingForm({ disableProjectFields = false, ...props }, ref) {
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { companyId, companyName } = props.record;

      const companyIdArray = companyId.split(",");
      const companyNameArray = companyName.split(",");

      return companyIdArray.map((id, index) => ({ id, name: companyNameArray[index]}));
    }
    return [];
  });
  const [initialValues] = useState(() => {
    if (props.record) {
      return undefined;
    }
    return [
      {
        product: props.defaultProduct,
        subProduct: props.defaultSubProduct,
        subProductId: props.defaultSubProductId,
        environment: props.defaultEnvironment,
      },
    ];
  });

  const fetchProjectOptions = useCallback((params) => {
    const setOptionsFromPagination = (option) => {
      setProjects(prev => uniqBy([...prev,...option], 'id'));
  };
    const { promise,cancel } =  ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, {...params, login_id: props.loginConfigId});
    promise.then((data) => setOptionsFromPagination(data.projects))
    return { promise,cancel}
}, [props.toolName, props.loginConfigId]);

  const getExtraFieldsData = useCallback((config) => {
    const { companyId } = config;
    const data = projects.reduce((acc,cv) =>{
      const { id, name } = cv;
      if(companyId.includes(id)){
        acc.id.push(id);
        acc.name.push(name);
      }
      return acc;
    },{id:[],name:[]})
    return ({
      companyId: data.id.join(),
      companyName: data.name.join()
    });
  },[projects]);

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    const { companyId } = config;
    return { companyId: companyId.split(",") };
  }, []);

  const extraFields = useMemo(() => ([
    {
      name: 'companyId',
      colSpan: '12',
      type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
      label: 'Company Name',
      required:true,
      disabled: disableProjectFields,
      props: {
        mode: "multiple",
        autoFocus: !disableProjectFields,
        optionFilterProp: 'filterLable',
        api: fetchProjectOptions,
      }
    }
  ]), [ disableProjectFields, fetchProjectOptions]);

  return (
    <GenericMappingForm
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      formDefaultValues={initialValues}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      {...props}
    />
  )
})

export default RiskReconMappingForm;